<template>
  <px-custom-dialog v-model="dialog"
                    content-class="rounded-card"
                    :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on"></slot>
    </template>
    <template v-slot:title>
      Adicionando fornecedores
    </template>
    <px-lista-selecao-fornecedores :comprador="cotacao.comprador"
                                   :produtos="[]"
                                   v-model="fornecedores"
                                   @resetfornecedor="clearFornecedores"/>
    <template v-slot:actions>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :loading="loading"
             :disabled="!fornecedores.length"
             @click="save">
        Enviar
      </v-btn>
      <v-btn @click="close" text class="normal-btn-text">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import CotacaoService from '@/modules/cotacao/cotacao-service';

export default {
  props: {
    cotacao: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      fornecedores: [],
    };
  },
  computed: {
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '90%' : '1000';
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    save() {
      this.loading = true;
      const payload = {
        idsFornecedores: this.fornecedores.map(f => f.id),
      };
      CotacaoService.addFornecedores(this.cotacao.id, payload)
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Fornecedores adicionados', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildInitialState() {
      this.fornecedores = [];
    },
    clearFornecedores() {
      this.fornecedores = [];
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        return;
      }
      this.buildInitialState();
    },
  },
};
</script>
